import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import RoutineMachine from "./RoutineMachine";
import { GeoapifyGeocoderAutocomplete, GeoapifyContext } from '@geoapify/react-geocoder-autocomplete'
import '@geoapify/geocoder-autocomplete/styles/minimal.css'
import Language from './language/language.json';
import 'leaflet/dist/leaflet.css';
 


const Map = (props) => {
 
	const rMachine 			= useRef();
	// const api_key 			= "09269ff07a4245ce84b1bcf2bbf8c415";
	const api_key 			= "54c39500401245279a6f273dcdc75636";
	
	const [name, setName] 	= useState();

	const source = props.source !== '' ? JSON.parse(props.source) : {lat:52.520008, lng:13.404954}; //default point
	const destination = props.destination !== '' ? JSON.parse(props.destination) : [{lat: null, lng: null}];
	
	const [accomodationList, setAccomodationList] = useState({});
	const [accomodation, setAccomodation] = useState(0);
	const [fromLatLong, setFromLatLong] = React.useState({
		lat: source.lat,
		lng: source.lng
	});

	const [toLatLong, seToLatLong] = React.useState({
		lat: destination[accomodation].lat,
		lng: destination[accomodation].lng
	});

	let defaultLocations =  [
		[fromLatLong.lat, fromLatLong.lng],
		[toLatLong.lat, toLatLong.lng]
	]

	const [locations, setLocations] = useState(defaultLocations);


	const updateMapRoutes = (locations) => {

		if (rMachine.current) {
			rMachine.current.setWaypoints(locations);
		}
	}

	const getDefaultLocationName = (locations) => {
 		let fromLatLong = locations[0];
		if(fromLatLong)
		{
			let lat = fromLatLong.lat ? fromLatLong.lat : fromLatLong[0];
			let lng = fromLatLong.lng ? fromLatLong.lng : fromLatLong[1];
		 
			const reverseGeocodingUrl = 'https://api.geoapify.com/v1/geocode/reverse?lat='+lat+'&lon='+lng+'&apiKey=' + api_key;
			fetch(reverseGeocodingUrl).then(result => result.json())
			.then(featureCollection => {

 				if (featureCollection.features.length === 0) {
					console.log("The address is not found");
					return;
				}
				const foundAddress = featureCollection.features[0];
				 
				setName('');
				setName(foundAddress.properties.formatted);
				updateMapRoutes(locations);
			});
		}
		
	};
	
	const getDefaultLocation = () => {
		 
		if (!navigator.geolocation) {
		   
		} else {
		    
		  navigator.geolocation.getCurrentPosition((position) => {

			let fromLatLong = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			}

			setFromLatLong(fromLatLong)

			let locations = [
				[fromLatLong.lat, fromLatLong.lng],
				[toLatLong.lat, toLatLong.lng]
			];

			setLocations(locations);
			getDefaultLocationName(locations)
 
		  }, () => {

 		  });
		}
	}

	

	useEffect(() => {
		document.documentElement.style.setProperty('--widget-color', props.color); 
		getDefaultLocation()	
		var accList = {}; 
		destination.map((acc,ind)=>{
			accList[ind] = acc;
		});
		setAccomodationList(accList);
	}, []);
 

	useEffect(() => {

		updateMapRoutes(locations);

	}, [locations, toLatLong]);

	const handleIconClick = () => {
		getDefaultLocation()	
	};

	function onPlaceSelect(value) {

		var properties = value.properties;

		let fromLatLongLocal =  {
			lat: properties.lat,
			lng: properties.lon
		};

		setFromLatLong(fromLatLong);

		setLocations([
			[fromLatLongLocal.lat, fromLatLongLocal.lng],
			[toLatLong.lat, toLatLong.lng]
		]);
	}

	//console.log("accomodationList",accomodationList);   
	return (
		<>
			<div className="main-anreise-form">
				<label htmlFor="header-search">
					<span className="">{Language[props.lang].toAddress}</span>
				</label>
				<select
					className="styled"
					name="accomodation"
					value={accomodation}
					onChange={(e)=>{setAccomodation(e.target.value); seToLatLong({lat:accomodationList[e.target.value].lat, lng:accomodationList[e.target.value].lng});}}
				>
					{
						(Object.keys(accomodationList).length > 0) && Object.values(accomodationList).map((acc,key)=>{
								return (<option key={key} value={key}>{acc.name}</option>)
						})
						
					}
				</select>
				<label htmlFor="header-search">
					<span className="">{Language[props.lang].startAddress}</span>
				</label>
				<div className="main-header-search">
					
					<GeoapifyContext apiKey={api_key}>

						<div className="header-search-wrapper">
							<GeoapifyGeocoderAutocomplete
								placeholder={Language[props.lang].enterStartAddress}
								value={name}
								placeSelect={onPlaceSelect}
								lang={props.lang} 
							/>
							<span className="header-search-icon" onClick={handleIconClick}>
								<svg xmlns="http://www.w3.org/2000/svg" width="19.432" height="19.432" viewBox="0 0 19.432 19.432">
									<path id="Icon_material-my-location" data-name="Icon material-my-location" d="M11.216,7.683a3.533,3.533,0,1,0,3.533,3.533A3.532,3.532,0,0,0,11.216,7.683Zm7.9,2.65A7.944,7.944,0,0,0,12.1,3.32V1.5H10.333V3.32A7.944,7.944,0,0,0,3.32,10.333H1.5V12.1H3.32a7.944,7.944,0,0,0,7.013,7.013v1.82H12.1v-1.82A7.944,7.944,0,0,0,19.112,12.1h1.82V10.333Zm-7.9,7.066A6.183,6.183,0,1,1,17.4,11.216,6.178,6.178,0,0,1,11.216,17.4Z" transform="translate(-1.5 -1.5)" fill="#fff"></path>
								</svg>
							</span>
						</div>
						<button>{Language[props.lang].calculateRoute}</button>

					</GeoapifyContext>
				</div>
			</div >
			{
				locations ? 
				<MapContainer
				doubleClickZoom={false}
				id="mapId"
				zoom={14}
				maxZoom={16}
				//center={locations[1]}
				attributionControl={true}
			>
				<TileLayer
					url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
					//url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
					attribution="Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri"
					//attribution='&copy; Stadia Maps&copy; OpenMapTiles &copy; OpenStreetMap'
				/>
				<RoutineMachine ref={rMachine} waypoints={locations} {...props} />
				
			</MapContainer>
			: 
			<></>
			}
			

		</>
	);
};

export default Map;